module.exports = __webpack_public_path__ + "static/img/online_pic2.eb3294d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic2.jpg
// module id = IK5r
// module chunks = 21